import React, { Component } from 'react';

import "./styles.css";

class HoverItem extends Component {
  render(){
    let headerClasses = ["hover-item-title"];
    if(this.props.headerClassNames){
      headerClasses = headerClasses.concat(this.props.headerClassNames);
    }
    return (
      <div className="hover-item-container">
          <h3 className={headerClasses.join(' ')}>
            <span className="hover-item-number">{this.props.number || 'NULL'}<span className="hover-item-number-red">{this.props.redNumber}</span></span>
            <span>{this.props.heading || 'hackatons'}</span>
          </h3>
          <div className="hover-item-content">
            {this.props.text}
          </div>
      </div>
    );
  }
}

export default HoverItem;



// WEBPACK FOOTER //
// ./src/components/HoverItem/HoverItem.js